import Vue from 'vue';
import createBridge, { createEventHub } from '@patsnap-utils/store-connect';
import Application from './components/Application';
import { setI18nInstance } from './config/i18nInstance';

/* 兼容landscape异步加载 */
if (!window.$bridge) window.$bridge = createBridge({ headerConfig: {} });
Vue.prototype.$eventHub = createEventHub(window.$bridge);

export default async function createApp(el, { vueI18nInstance }) {
    setI18nInstance(vueI18nInstance);
    return new Vue({
        i18n: vueI18nInstance,
        el,
        render(h) {
            return h(Application);
        },
    });
}
